import { render } from "./socials.vue?vue&type=template&id=f7546fe2&scoped=true"
import script from "./socials.vue?vue&type=script&lang=js"
export * from "./socials.vue?vue&type=script&lang=js"

import "./socials.vue?vue&type=style&index=0&id=f7546fe2&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7546fe2"]])

export default __exports__